export const TherapistIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 9C10.2091 9 12 7.2091 12 5C12 2.79086 10.2091 1 8 1C5.79086 1 4 2.79086 4 5C4 7.2091 5.79086 9 8 9Z"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 13.9948C17 14.5211 16.7922 15.0265 16.421 15.4003C15.5667 16.2613 14.7381 17.1591 13.8518 17.9888C13.6487 18.1762 13.3265 18.1694 13.1321 17.9734L10.5788 15.4003C9.80706 14.6226 9.80706 13.367 10.5788 12.5892C11.3582 11.8038 12.6278 11.8038 13.4071 12.5892L13.4999 12.6828L13.5927 12.5892C13.9664 12.2125 14.4753 12 15.0068 12C15.5385 12 16.0474 12.2124 16.421 12.5892C16.7922 12.9631 17 13.4686 17 13.9948Z"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M1 17V16C1 12.134 4.13401 9 8 9C9.0736 9 10.0907 9.2417 11 9.6736"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
